








































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import dokument from '@/store/modules/dokument';
import { ImageSection } from '@/store/models';
import alert from '@/store/modules/alert';
import * as api from '@/store/api';

@Component({ components: {} })
export default class CustomImage extends Vue {
  @Prop() readonly group!: any;

  fetching: boolean = false;
  title: string = '';
  blobId: string = '';

  @Watch('section', { immediate: true, deep: true })
  onData() {
    this.title = this.section.Title;
    this.blobId = this.section.Src;
    if (this.group.Hidden !== this.hidden) {
      const g = {
        Id: this.group.Id,
        Kind: this.group.Kind,
        Type: this.group.Type,
        SubType: this.group.SubType,
        Children: this.group.Children,
        Hidden: this.hidden,
      };
      dokument.updateItem(g);
    }
  }

  @Watch('title', { immediate: false, deep: false })
  onTitleChanged() {
    this.update();
  }

  update() {
    if (this.section.Title === this.title && this.section.Src === this.blobId) {
      return;
    }

    const s = {
      Id: this.section.Id,
      Kind: this.section.Kind,
      Type: this.section.Type,
      SubType: this.section.SubType,
      Hidden: this.blobId === '',
      Src: this.blobId,
      Title: this.title,
    };
    dokument.updateItem(s);
    this.fetching = false;
  }

  chooseFile() {
    const input: any = this.$refs.imageInput;
    input.click();
  }

  reset() {
    this.blobId = '';
    if (this.section.Title === '') {
      this.update();
    } else {
      this.title = '';
    }
  }

  clear() {
    const input: any = this.$refs.imageInput;
    input.type = 'text';
    input.type = 'file';
  }

  fileAdded() {
    const me = this;
    const store = this.$store;
    const router = this.$router;
    const formData = new FormData();
    const inputs: any = this.$refs.imageInput;
    const input: any = inputs.files[0];
    const name = input.name.toLowerCase();

    formData.append('file', input);
    me.fetching = true;
    api
      .uploadBlob(formData)
      .then((response: any) => {
        me.clear();
        this.blobId = response.data;
        this.update();
      })
      .catch((error) => {
        const apiError = error.error.response.data;
        me.clear();
        this.fetching = false;
        alert.setError(apiError);
      });
  }

  get section(): ImageSection {
    return dokument.getItems(this.group.Id)[0] as ImageSection;
  }

  get src() {
    if (this.section.Src) {
      return `/api/user/blob/${this.section.Src}`;
    }
    return '/static/photo-placeholder.jpg';
  }

  get hidden(): boolean {
    if (this.section.Title) {
      return false;
    }
    return !this.section.Src;
  }
}
